export default __webpack_public_path__ + "static/media/photo--sm--roustem.6ba92a7b.jpg";